export default __webpack_public_path__ + "static/media/icon.7ed5263b.svg";